module.exports = __webpack_public_path__ + "static/media/customer.eaf35156.jpg";